import { NavLink } from "react-router-dom";
/** Onglets de l'admin des cours : la liste de tous les cours et les thématiques. */
export default function AdminCoursesTabs() {
  const cls = ({ isActive }) =>
    `px-4 py-2 rounded-md text-sm transition-colors ${isActive ? "bg-emerald-500 text-black font-medium" : "text-zinc-400 hover:text-white"}`;
  return (
    <div className="inline-flex items-center gap-1 rounded-lg bg-white/[0.03] border border-white/5 p-1 mb-6" data-testid="admin-courses-tabs">
      <NavLink to="/admin/cours" end className={cls}>Tous les cours</NavLink>
      <NavLink to="/admin/cours/thematiques" className={cls}>Thématiques</NavLink>
    </div>
  );
}
